import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Posizione } from '../shared/models/posizione.model';

@Injectable({ providedIn: 'root' })
export class HierarchyService {
  constructor(private appConfig: AppConfig,) { }

  getHierarchyLabels(): string[] {
    return this.appConfig.logic.hierarchy.labels;
  }

  getDescriptionIndex(): number {
    return this.appConfig.logic.hierarchy.descriptionIndex;
  }

  getDescription(posizione: Posizione[]): string | null | undefined {
    return posizione[this.appConfig.logic.hierarchy.descriptionIndex].descrizione;
  }

  getSigla(posizione: Posizione[]): string {
    return posizione[this.appConfig.logic.hierarchy.descriptionIndex].sigla;
  }
}
